// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ff01fdb5","header":"_c284dcb9","copy":"_42f6dbc3","dot":"_36954ab9","isSoldDot":"_a3a9b7f7","isOnHoldDot":"_1c5c824d","isSold":"_e9cf47c8","isOnHold":"_b96b0732"};